<script setup lang="ts">
import BaseBadge from "@/components/Base/Badge.vue";
import BaseIcon from "@/components/Base/Icon/index.vue";
import BaseListItem from "@/components/Base/ListItem.vue";
import type { SchoolClass } from "@/services/fobizzToolsApi";
import { SchoolClassTypeEnum } from "@/services/fobizzToolsApi";
import type { SimpleRouteLocationRaw } from "@/types/router.types";
import type { RouteLocationRaw } from "vue-router";

const props = defineProps<{ item: SchoolClass }>();
defineEmits(["duplicate"]);

const { t } = useI18n();

const schoolClassRoute: ComputedRef<RouteLocationRaw> = computed(() => {
  return {
    name: "teacher-school-class-show",
    params: {
      id: props.item.id,
    },
  };
});
</script>

<template>
  <BaseListItem
    :item="item"
    icon="bi bi-people"
    icon-color="$color-secondary"
    :to="schoolClassRoute as SimpleRouteLocationRaw"
  >
    <template #label>
      {{ item.name }}
      <BaseBadge
        v-if="(item as SchoolClass).classType === SchoolClassTypeEnum.ONETIME"
        v-tooltip="t('schoolClass.classroom.tooltips.onetimeIcon')"
        state="light"
        class="ms-2 tooltip-in-stretched-link"
        small-x-padding
      >
        <BaseIcon icon-name="hourglass-split" class="one-time-icon" size="md" />
      </BaseBadge>
    </template>
  </BaseListItem>
</template>

<style lang="scss" scoped>
.one-time-icon {
  color: $color-system-meta;
}
</style>
